export function remainingTime(timer, now) {
  const duration = Math.max(0, timer.duration * 1000);
  if (timer.status === 'prepare' || timer.startTime == null) return duration;
  const end = timer.status === 'active' ? now : timer.pauseTime ?? timer.startTime;
  return Math.max(0, duration - Math.max(0, end - timer.startTime));
}

export function timerText(timer, now) {
  const seconds = Math.ceil(remainingTime(timer, now) / 1000);
  return Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
}

export function groupTimers(timers, group) {
  return group ? timers.filter(timer => timer.status !== 'prepare' && timer.groups.includes(group)) : [];
}
